/*封装请求方法 axios*/
import axios from '@/plugins/axios'
import store from '@/store';
import { useRouter } from 'vue-router';
import {ElMessageBox } from 'element-plus';
// this.axios.defaults.timeout = 20000
// // this.axios.defaults.withCredentials=true
// axios.defaults.crossDomain=true
let wraning_msg = null;
export default {
    fetchGet (url, params = {}) {
      return new Promise((resolve, reject) => {
        axios.get(url, { params }).then(res => {
          const that = this;
          if(res && res.code){
            if(res.message && res.code>=500){
              if(!wraning_msg){
                if(res.code == 501){
                  wraning_msg = ElMessageBox.alert('请重新登录！', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                      store.signOut();
                      wraning_msg = null;
                      that.toPage('/login');
                    },
                  })
                }
                if(res.code == 500 || res.code == 502){
                  wraning_msg = ElMessageBox.alert(res.code == 500?res.message:'未开通权限，请与管理员联系！', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                      wraning_msg = null;
                    },
                  })
                }
              }
            }
          }
          // if (res.code && res.code == 502) {
          //   store.signOut();
          //   this.toPage('/login');
          // }
          resolve(res)
          }).catch(error => {
          reject(error)
        })
      })
    },
    fetchPost (url, params = {},res_params = null) {
      return new Promise((resolve, reject) => {
        axios.post(url, params,res_params).then(res => {
          const that = this;
          if(res && res.code){
            if(res.message && res.code>=500){
              if(!wraning_msg){
                if(res.code == 501){
                  wraning_msg = ElMessageBox.alert('请重新登录！', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                      store.signOut();
                      wraning_msg = null;
                      that.toPage('/login');
                    },
                  })
                }
                if(res.code == 500 || res.code == 502){
                  wraning_msg = ElMessageBox.alert(res.code == 500?res.message:'未开通权限，请与管理员联系！', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                      store.signOut();
                      wraning_msg = null;
                      that.toPage("/login")
                    },
                  })
                }
              }
            }
          }
          // if (res.code && res.code == 502) {
          //   store.signOut();
          //   this.toPage('/login');
          // }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    toPage (url) {
      let router = useRouter();
      router.push(url);
    }
  }
